import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Divider } from "@mui/material";
import Stack from "@mui/material/Stack";
import { NavDrawerLinks } from "../NavDrawerLinkComponents/NavDrawerLinks";
import { OrderNowButton } from "../OrderNowButton";
import { NavLogOutLink } from "./NavLogOutLink";
import { useNavLinks } from "../hooks/useNavLinks";
export const MainLinksContent = () => {
    const { navDrawerBottomLinks, navDrawerTopLinks } = useNavLinks();
    return (_jsxs(_Fragment, { children: [_jsx(OrderNowButton, { sx: { width: "75%", alignSelf: "center" } }), _jsxs(Stack, Object.assign({ spacing: 1 }, { children: [_jsx(NavDrawerLinks, { links: navDrawerTopLinks }), _jsx(Box, Object.assign({ width: "100%" }, { children: _jsx(Divider, { variant: "middle", sx: { mb: 2 } }) })), _jsx(NavDrawerLinks, { links: navDrawerBottomLinks }), _jsx(NavLogOutLink, { classes: "is-nav-drawer-logout" })] }))] }));
};
